import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { rootRoute } from '@/tenant/settings/root'
import { appState } from '@/appState'

export const communicationRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/communication',
    component: lazyRouteComponent(() => import('./Communication'), 'Communication'),
    loader: async ({ abortController, parentMatchPromise }) => {
        await parentMatchPromise

        const [communicationSettings, { templates: emailTemplates }] = await Promise.all([
            client.tenants.getTenantCommunicationSettings.query(
                {
                    tenantId: appState.tenant!._id.toString(),
                },
                { signal: abortController.signal }
            ),
            client.tenants.email.listEmailTemplates.query(
                {
                    tenantId: appState.tenant!._id.toString(),
                },
                { signal: abortController.signal }
            ),
        ])

        return { communicationSettings, emailTemplates }
    },
})
